import { Sha256 } from "@aws-crypto/sha256-browser";
import { Uint8ArrayToHex } from "./util";
export async function sha256(val) {
  const hash = new Sha256();
  hash.update(val);
  // @ts-ignore
  return Uint8ArrayToHex(await hash.digest("hex"));
}